import React from 'react';
import AutoSaveDropdown from "./AutoSaveDropdown";

import * as ResourceApi from 'api/resources';

/*

Generic dropdown that let's you select from a list of resources.

There's a non-autosave version of this also, so if you make edits, edit that one too!

*/

class AutoSaveResourceDropdown extends React.Component {
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
          options: props.options || [],
          loading: true,
          defaultValue: props.defaultValue
        };

    }

    componentDidMount() {

        // This code performs ajax to load resources - it's not obvious if duplicative of
        // import {createResourceTypeSelector} from 'resources/selectors';
        // const getNgcEndpoints = createResourceTypeSelector(ResourceApi.Types.NgcEndpoint);

        const foo = ResourceApi.getAll(this.props.resource, this.props.resourceSortOptions, this.props.resourceFilter);

        const _this = this;

        foo.subscribe((response) => {

            let options = response.response.object.map(function(item) {
                return _this.props.itemTransformer(item);
            });

            let defaultValue = this.props.defaultValue
            if (!defaultValue) {
                let defaultItem = response.response.object.find(function(item) {
                    if (item.hasOwnProperty('isDefault')) {
                        if (item.isDefault) {
                            return item
                        }
                    }
                });

                if (defaultItem) {
                    defaultValue = defaultItem.id; 
                } else {
                    if (options && options.length > 0) {
                        defaultValue = options.value;
                    }
                }
            }



            _this.setState({ 
                options: options,
                loading: false,
                defaultValue: "" + defaultValue
            });

        });
    
    }

    render() {

        return <AutoSaveDropdown 
                    {...this.props} 
                    options={this.state.options} 
                    loading={this.state.loading }
                    defaultValue={this.state.defaultValue} 
                />
    }
  }

  
  export default AutoSaveResourceDropdown;
  


  


// WEBPACK FOOTER //
// ./public/components/forms/AutoSaveFormFields/AutoSaveResourceDropdown.jsx